import { type ServiceConfig } from '../../ServiceRegistry';
import BaseService from '@/services/BaseService';

/**
 * Investor service configurations
 * These services are used by the investor module
 */
export const investorServices: ServiceConfig[] = [
  {
    name: 'investorService',
    factory: () => new BaseService('/api/investor'),
  },
  {
    name: 'investorReportService',
    factory: () => new BaseService('/api/investor/reports'),
  },
  {
    name: 'investorAnalyticsService',
    factory: () => new BaseService('/api/investor/analytics'),
  },
  {
    name: 'investorPortfolioService',
    factory: () => new BaseService('/api/investor/portfolio'),
  },
];

/**
 * Investor-specific service factory
 * Creates a custom service with investor-specific configuration
 */
export const createInvestorCustomService = (serviceName: string, baseUrl: string = '/api/investor'): ServiceConfig => ({
  name: serviceName,
  factory: () => new BaseService(baseUrl),
});

/**
 * Investor service utilities
 */
export const investorServiceUtils = {
  /**
   * Get all investor service names
   */
  getServiceNames: () => investorServices.map(s => s.name),

  /**
   * Check if a service name is an investor service
   */
  isInvestorService: (name: string) => investorServices.some(s => s.name === name),

  /**
   * Get investor base path
   */
  getBasePath: () => '/securitization/investor',
};
